import React, { useState } from 'react';
import { ExternalLink, Github } from 'lucide-react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { projects } from '../data/mock';

const ProjectsSection = () => {
  const [showAll, setShowAll] = useState(false);
  const displayedProjects = showAll ? projects : projects.filter(p => p.featured);

  return (
    <section id="projects" className="py-20 bg-gradient-to-b from-gray-900 to-black">
      <div className="container mx-auto px-4">
        
        <div className="text-center mb-16 space-y-4">
          <span className="text-blue-400 text-sm font-mono uppercase tracking-wider">Portfólio</span>
          <h2 className="text-4xl md:text-5xl font-bold text-white">
            Projetos em Destaque
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Alguns dos projetos que desenvolvi utilizando as mais modernas tecnologias
          </p>
        </div>

        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {displayedProjects.map((project, index) => (
            <Card
              key={project.id}
              className="bg-gray-900/50 border-gray-800 hover:border-blue-500/50 transition-all duration-300 hover:shadow-xl hover:shadow-blue-500/10 group overflow-hidden backdrop-blur-sm"
              style={{
                animationDelay: `${index * 100}ms`
              }}
            >
              
              <div className="relative h-48 bg-gradient-to-br from-blue-500/20 to-purple-600/20 overflow-hidden">
                <div className="absolute inset-0 flex items-center justify-center">
                  <img src={project.image} alt={project.alt} />
                </div>
                
                <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center gap-4">
                  <Button
                    size="sm"
                    className="bg-white/10 hover:bg-white/20 text-white backdrop-blur-sm"
                    onClick={() => window.open(project.demoUrl, '_blank')}
                  >
                    <ExternalLink size={16} className="mr-2" />
                    Demo
                  </Button>
                 
                </div>
              </div>

           
              <div className="p-6 space-y-4">
                <h3 className="text-xl font-semibold text-white group-hover:text-blue-400 transition-colors">
                  {project.name}
                </h3>

                <p className="text-gray-400 text-sm leading-relaxed line-clamp-3">
                  {project.description}
                </p>

                
                <div className="flex flex-wrap gap-2">
                  {project.technologies.map((tech) => (
                    <span
                      key={tech}
                      className="text-xs px-2 py-1 bg-blue-500/10 text-blue-400 rounded border border-blue-500/20"
                    >
                      {tech}
                    </span>
                  ))}
                </div>

               
                <div className="flex gap-3 pt-2">
                  <Button
                    size="sm"
                    variant="ghost"
                    className="text-blue-400 hover:text-blue-300 hover:bg-blue-500/10"
                    onClick={() => window.open(project.demoUrl, '_blank')}
                  >
                    <ExternalLink size={16} className="mr-2" />
                    Ver Demo
                  </Button>
                 
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* Show More Button */}
        {projects.length > 3 && (
          <div className="text-center">
            <Button
              onClick={() => setShowAll(!showAll)}
              size="lg"
              variant="outline"
              className="border-gray-700 text-white hover:bg-white/5"
            >
              {showAll ? 'Mostrar Menos' : 'Ver Todos os Projetos'}
            </Button>
          </div>
        )}
      </div>
    </section>
  );
};

export default ProjectsSection;